document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-luxe-header]');
  if (!header) return;

  const triggers = [...header.querySelectorAll('[data-mega-trigger]')];
  const panels = [...header.querySelectorAll('[data-mega-panel]')];
  const menuItems = [...header.querySelectorAll('.luxe-header__menu-item')];

  let activeIndex = null;
  let closeTimer = null;

  const clearCloseTimer = () => {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
  };

  const closeAll = () => {
    activeIndex = null;

    menuItems.forEach((item) => item.classList.remove('is-open'));

    triggers.forEach((trigger) => {
      const link = trigger.querySelector('.luxe-header__menu-link');
      if (link) link.setAttribute('aria-expanded', 'false');
    });

    panels.forEach((panel) => panel.classList.remove('is-open'));
  };

  const openPanel = (index) => {
    clearCloseTimer();
    activeIndex = index;

    menuItems.forEach((item) => item.classList.remove('is-open'));
    panels.forEach((panel) => panel.classList.remove('is-open'));

    const trigger = triggers.find(
      (item) => item.getAttribute('data-mega-trigger') === String(index)
    );
    const panel = panels.find(
      (item) => item.getAttribute('data-mega-panel') === String(index)
    );

    if (trigger) {
      trigger.classList.add('is-open');
      const link = trigger.querySelector('.luxe-header__menu-link');
      if (link) link.setAttribute('aria-expanded', 'true');
    }

    if (panel) panel.classList.add('is-open');
  };

  const scheduleClose = () => {
    clearCloseTimer();
    closeTimer = setTimeout(() => {
      closeAll();
    }, 140);
  };

  triggers.forEach((trigger) => {
    const index = trigger.getAttribute('data-mega-trigger');

    trigger.addEventListener('mouseenter', () => openPanel(index));
    trigger.addEventListener('focusin', () => openPanel(index));

    const link = trigger.querySelector('.luxe-header__menu-link');
    if (link && link.tagName === 'BUTTON') {
      link.addEventListener('click', () => {
        if (activeIndex === index) {
          closeAll();
        } else {
          openPanel(index);
        }
      });
    }
  });

  panels.forEach((panel) => {
    panel.addEventListener('mouseenter', clearCloseTimer);
    panel.addEventListener('mouseleave', scheduleClose);
  });

  const nav = header.querySelector('.luxe-header__nav');
  if (nav) {
    nav.addEventListener('mouseleave', scheduleClose);
    nav.addEventListener('mouseenter', clearCloseTimer);
  }

  header.addEventListener('mouseleave', scheduleClose);
  header.addEventListener('mouseenter', clearCloseTimer);

  document.addEventListener('scroll', () => {
    closeAll();
  }, { passive: true });

  document.addEventListener('click', (event) => {
    if (!header.contains(event.target)) {
      closeAll();
    }
  });

  const noLinkItems = header.querySelectorAll('[data-no-link="true"]');
  noLinkItems.forEach((item) => {
    item.addEventListener('click', (event) => {
      event.preventDefault();
    });
  });
});